import $ from 'jquery';
import mq from '../utils/media-queries';
import '../utils/click-twice-to-go';

const openFlag = 'nav-expanded';
const openClass = `.${openFlag}`;
const menuClass = '.main-menu';
const parentClass = `${menuClass}__item--parent`;
const dropdownTrigger = `${menuClass}__item--parent > ${menuClass}__link`;

// TODO aria attributes

export default {
  initialized: false,

  _bindEvents(setup=true) {
    // ENHANCEMENT: refactor this

    const parentLinks = document.querySelectorAll(dropdownTrigger);
    [].forEach.call(parentLinks, parentLink => {

      parentLink.addEventListener('click', e => {
        if ( mq.isMinWidth('nav') ) {
          this.toggle(parentLink.parentNode);
        }
      });
    });

    $(dropdownTrigger).clickTwiceToGo(); // ENHANCEMENT: unbind

    $(document).on('click', e => {
      if ( mq.isMinWidth('nav') ) {
        if ( !$(e.target).closest(openClass).length ) this.closeAll();
      }
    });

    document.addEventListener('keydown', e => {
      if ( mq.isMinWidth('nav') ) {
        if ( e.key == 'Escape' ) this.closeAll();
      }
    });

  },

  _setup() {
    this.closeAll();

    if ( !this.initialized ) {
      this._bindEvents();
      this.initialized = true;
    }
  },

  _teardown() {

    if ( this.initialized ) {
      this.openAll();
    }
  },

  init() {
    mq.onMinWidth('nav', () => this._setup() );
    mq.onMaxWidth('nav', () => this._teardown() );
  },

  isOpen(el) {
    return el.classList.contains(openFlag)
  },

  toggle(el) {
    this.closeOthers(el);
    el.classList.toggle(openFlag)
    $(el).find(menuClass).slideToggle(170);
  },

  open(el) {
    el.classList.add(openFlag)
    $(el).find(menuClass).slideDown(170);
  },

  close(el) {
    el.classList.remove(openFlag)
    $(el).find(menuClass).slideUp(170);
  },

  closeOthers(el) {
    const openMenus = document.querySelectorAll(openClass);
    [].forEach.call( openMenus, expanded => {
      if ( expanded != el ) this.close(expanded);
    });
  },

  closeAll() {
    const openMenus = document.querySelectorAll(openClass);
    [].forEach.call( openMenus, expanded => this.close(expanded) );
  },

  openAll() {
    const allMenus = document.querySelectorAll(parentClass);
    [].forEach.call( allMenus, el => this.open(el) );
  },

}
